import { Box, Divider, Link as MuiLink, Stack } from "@mui/material";
import type { RootState } from "@stores/store";
import {
  catalogIconMap,
  MENU_ALL_PRODUCT_KEY,
  MENU_COLLECTION_KEY,
  MENU_MY_FAVORITE_KEY,
} from "constants/catalog";
import Link from "next/link";
import * as React from "react";
import { useSelector } from "react-redux";
import CategoryTopMenu from "./categoryTopMenu";

type Props = { slugs: string[] };

const unfoldChildrenCatalog = (arr = [], catalog) => {
  for (let i = 0; i < catalog.children.length; i++) {
    const child = catalog.children[i];
    arr.push({
      id: child.id,
      slug: child.key,
      href: `/custom/${child.key}`,
      name: child.name,
    });
    if (child.children && child.children.length > 0) {
      for (let j = 0; j < child.children.length; j++) {
        arr = unfoldChildrenCatalog(arr, child.children[j]);
      }
    }
  }

  return arr;
};

export default function CategorySelector({ slugs }: Props): React.ReactElement {
  const catalog = useSelector((store: RootState) => store.app.catalog);
  const collections = useSelector((store: RootState) => store.app.collection);

  // const children
  const topCategoryPropsMap = React.useMemo(() => {
    const map: { [key: string]: any } = {
      [MENU_ALL_PRODUCT_KEY]: {
        name: "All products",
        categoryKey: MENU_ALL_PRODUCT_KEY,
      },
      [MENU_MY_FAVORITE_KEY]: {
        name: "My favorites",
        categoryKey: MENU_MY_FAVORITE_KEY,
      },
      [MENU_COLLECTION_KEY]: {
        name: "Collections",
        categoryKey: MENU_COLLECTION_KEY,
        open: slugs?.length === 2 && slugs[0] === "collections",
        childrenItems: collections.map((item) => ({
          name: item.name,
          slug: item.slug,
          href: `/custom/collections/${item.slug}`,
        })),
      },
    };

    for (let i = 0; i < catalog.length; i++) {
      const item = catalog[i];
      const childrenItems = unfoldChildrenCatalog([], item);
      map[item.key] = {
        icon: catalogIconMap[item.key],
        name: item.name,
        categoryKey: item.key,
        childrenItems,
        allHref: `/custom/${item.key}`,
      };
    }
    return map;
  }, [catalog]);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 100,
      }}
    >
      <Stack spacing={1}>
        <Link href="/custom/all" passHref>
          <MuiLink color="inherit" underline="none">
            <CategoryTopMenu {...topCategoryPropsMap[MENU_ALL_PRODUCT_KEY]} />
          </MuiLink>
        </Link>
        <Link href="/custom/favorites" passHref>
          <MuiLink color="inherit" underline="none">
            <CategoryTopMenu {...topCategoryPropsMap[MENU_MY_FAVORITE_KEY]} />
          </MuiLink>
        </Link>
        <Divider />
        {catalog.map((item) => {
          return (
            <CategoryTopMenu
              key={item.key}
              {...topCategoryPropsMap[item.key]}
            />
          );
        })}
        <Divider />
        <CategoryTopMenu {...topCategoryPropsMap[MENU_COLLECTION_KEY]} />
      </Stack>
    </Box>
  );
}
